/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierAdvancedExtendedRuntimeEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('TIER_ADVANCED_EXTENDED_RUNTIME_ENABLED'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierAdvancedExtendedRuntimeEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierAdvancedExtendedRuntimeEnabledSettingParser.decode(input).map(res => new TierAdvancedExtendedRuntimeEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierAdvancedExtendedRuntimeEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierAdvancedExtendedRuntimeEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierAdvancedExtendedRuntimeEnabledSettingParser.schema();
    }
}
